import { lazy } from 'react'

const ApexCharts = lazy(() => import('../../views/charts/apex'))

const ChartMapsRoutes = [
  {
    path: '/charts/apex',
    element: <ApexCharts />
  }
]

export default ChartMapsRoutes
